import { useSelector } from 'react-redux'
import {
  Loading,
  selectCBstatsLoading,
  selectOwnershipLoading,
} from '../../../store/web3/collection.state'

export function useNftLoadingState() {
  const statsLoadingState = useSelector(selectCBstatsLoading)
  const ownerStatsLoadingState = useSelector(selectOwnershipLoading)
  const statsLoaded = statsLoadingState === Loading.SUCCESSFUL
  const ownerStatsLoaded = ownerStatsLoadingState === Loading.SUCCESSFUL

  return { statsLoaded, ownerStatsLoaded }
}
